import { VectorLayerData } from "../components/vector_component"

const source = "ind:lulc_lempake"

interface LulcClass {
    label: string
    value: string
}

/** Detailed penggunaan lahan classes. The same names occur in PL_2023 and PL_2025. */
const landUseClasses: LulcClass[] = [
    { label: "Settlement", value: "Permukiman" },
    { label: "Trade and services", value: "Perdagangan dan Jasa" },
    { label: "Industry", value: "Industri" },
    { label: "Road", value: "Jalan" },
    { label: "Mixed garden", value: "Kebun Campuran" },
    { label: "Oil palm", value: "Kebun Sawit" },
    { label: "Paddy field", value: "Sawah" },
    { label: "Dry field", value: "Tegalan" },
    { label: "Shrub", value: "Belukar" },
    { label: "Bush", value: "Semak" },
    { label: "Swamp bush", value: "Semak Rawa" },
    { label: "Open land", value: "Lahan Terbuka" },
    { label: "Open-pit mining (excluding sand and gravel)", value: "Pertambangan Terbuka non Sirtu" },
    { label: "River", value: "Sungai" },
    { label: "Canal", value: "Kanal" },
    { label: "Pond", value: "Kolam" },
    { label: "Reservoir", value: "Waduk" },
]

/**
 * IKLH roll-up. The 2025 attribute spells open land "Lahan terbuka";
 * 2023 uses "Lahan Terbuka". Both display as "Open land".
 */
const iklhClasses2023: LulcClass[] = [
    { label: "Settlement / Built-up", value: "Permukiman / Lahan terbangun" },
    { label: "Plantation / Garden", value: "Perkebunan / Kebun" },
    { label: "Paddy field", value: "Sawah" },
    { label: "Dryland agriculture", value: "Pertanian lahan kering" },
    { label: "Shrub", value: "Belukar" },
    { label: "Swamp shrub", value: "Belukar Rawa" },
    { label: "Open land", value: "Lahan Terbuka" },
    { label: "Mining", value: "Pertambangan" },
    { label: "Water body", value: "Tubuh Air" },
]

const iklhClasses2025: LulcClass[] = iklhClasses2023.map(cls =>
    cls.value === "Lahan Terbuka" ? { ...cls, value: "Lahan terbuka" } : cls
)

function booleanClass(name: string, key: string, value: string, classification: string, year: string): VectorLayerData {
    return {
        name,
        source: [source],
        key,
        value: [value],
        output: "BooleanTileGrid",
        distributed: false,
        wms: false,
        groups: [classification, year],
    }
}

function categorical(name: string, key: string, classes: LulcClass[], classification: string, year: string): VectorLayerData {
    return {
        name,
        source: [source],
        key,
        value: classes.map(cls => cls.value),
        labels: classes.map(cls => cls.label),
        output: "CategoricalTileGrid",
        distributed: false,
        wms: false,
        groups: [classification, year],
    }
}

function yearLayers(
    classification: string,
    year: string,
    key: string,
    classes: LulcClass[],
    categoricalName: string
): VectorLayerData[] {
    return [
        ...classes.map(cls => booleanClass(`${cls.label} (${year})`, key, cls.value, classification, year)),
        categorical(`${categoricalName} (${year})`, key, classes, classification, year),
    ]
}

export const LulcLempakeProperties: VectorLayerData[] = [
    ...yearLayers("Land use", "2023", "PL_2023", landUseClasses, "Land use"),
    ...yearLayers("Land use", "2025", "PL_2025", landUseClasses, "Land use"),
    ...yearLayers("IKLH", "2023", "PL23IKLH", iklhClasses2023, "IKLH"),
    ...yearLayers("IKLH", "2025", "PL25IKLH", iklhClasses2025, "IKLH"),
]
